import {blue, brand} from "@templates/shared-theme/themePrimitives"

export const Roles = Object.freeze({
    CLUB_ADMIN: { symbol: Symbol("ClubAdmin"), level: 4 , translationKey: "role:clubAdmin", color: brand[500]},
    CLUB_EMPLOYEE: { symbol: Symbol("ClubEmployee"), level: 3 , translationKey: "role:clubEmployee", color: brand[300]},
    SITE_ADMIN: { symbol: Symbol("SiteAdmin"), level: 2 , translationKey: "role:siteAdmin", color: blue[300]},
    SITE_EMPLOYEE: { symbol: Symbol("SiteEmployee"), level: 1 , translationKey: "role:siteEmployee", color: blue[100]}
});

const roleMapping = {
    "Club admin": Roles.CLUB_ADMIN,
    "Club employee": Roles.CLUB_EMPLOYEE,
    "Site admin": Roles.SITE_ADMIN,
    "Site employee": Roles.SITE_EMPLOYEE
};

export function mapRole(apiRoleName) {
    return roleMapping[apiRoleName] || null;
}


/**
 * Checks if the current role has equal or higher level than the compared role
 * @param {Object} currentRole - The current user's role
 * @param {Object} comparedRole - The role to compare against
 * @returns {boolean} - True if current role has equal or higher level
 */
export function hasEqualOrHigherRole(currentRole, comparedRole) {
    if (!currentRole || !comparedRole) return false;
    return currentRole.level >= comparedRole.level;
}

/**
 * Checks if the current role has higher level than the compared role
 * @param {Object} currentRole - The current user's role
 * @param {Object} comparedRole - The role to compare against
 * @returns {boolean} - True if current role has higher level
 */
export function hasHigherRole(currentRole, comparedRole) {
    if (!currentRole || !comparedRole) return false;
    return currentRole.level > comparedRole.level;
}

/**
 * Checks if the current role is exactly the compared role
 * @param {Object} currentRole - The current user's role
 * @param {Object} comparedRole - The role to compare against
 * @returns {boolean} - True if roles are exactly the same
 */
export function hasExactRole(currentRole, comparedRole) {
    if (!currentRole || !comparedRole) return false;
    return currentRole.symbol === comparedRole.symbol;
}

/**
 * Checks if the current role has lower level than the compared role
 * @param {Object} currentRole - The current user's role
 * @param {Object} comparedRole - The role to compare against
 * @returns {boolean} - True if current role has lower level
 */
export function hasLowerRole(currentRole, comparedRole) {
    if (!currentRole || !comparedRole) return false;
    return currentRole.level < comparedRole.level;
}

/**
 * Checks if the current role has equal or lower level than the compared role
 * @param {Object} currentRole - The current user's role
 * @param {Object} comparedRole - The role to compare against
 * @returns {boolean} - True if current role has equal or lower level
 */
export function hasEqualOrLowerRole(currentRole, comparedRole) {
    if (!currentRole || !comparedRole) return false;
    return currentRole.level <= comparedRole.level;
}
